module.exports = __webpack_public_path__ + "img/Scatter Plot Analysis.92f74085.png";